export * from './ngs-reveal.service';
export * from './ngs-reveal-config';
export * from './window.service';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
